import React from 'react';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages/ai-config-items';
import TableIcon from '@atlaskit/icon/core/table';

import { createInsertBelow, createReplace } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type {
	EditorPluginAIConfigItemWithOptionsFactory,
	EditorPluginAIConfigItemFactory,
} from '../../config-items';

const intentSchemaId = 'convert_to_table.json';

export const convertToTable: EditorPluginAIConfigItemFactory = (options) => ({
	key: CONFIG_ITEM_KEYS.CONVERT_TO_TABLE,
	title: aiConfigItemMessages.convertToTableTitle,
	description: aiConfigItemMessages.convertToTableDescription,
	icon: () => <TableIcon label="" spacing="spacious" />,
	statusLozengeType: 'beta',
	intentSchemaId,
	actions: {
		selection: [
			createInsertBelow({ appearance: 'secondary', factoryOptions: options }),
			createReplace({ appearance: 'primary' }),
		],
	},
});

export const convertToTableWithOptions: EditorPluginAIConfigItemWithOptionsFactory = (options) => ({
	config: convertToTable(options),
	triggers: { empty: { enabled: false }, selection: { enabled: true } },
});
